export default __webpack_public_path__ + "41cabf4ae500dbd6b9b0a87f33bef7d0.svg";